<div *ngIf="message"
     [ngClass]="{ show: show }"
     class="snackbar"
     [ngStyle]="{ 'background-color': 'rgb(var(--' + color + '))' }">
  <div *ngIf="title || manualClose"
       class="modal-header pb-0"
       [ngClass]="{ 'no-title': !title }">
    <h5 *ngIf="title"
        class="text-white mb-0">{{ title | translate }}</h5>
    <button *ngIf="manualClose"
            type="button"
            class="close custom-close"
            [ngClass]="{ 'no-title': !title }"
            (click)="close.emit()"
            aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-body-custom custom-tag-pre"
       [innerHTML]="message | translate:messageExtension"></div>
</div>